/**
 * Firebase web app configuration for Chore Champion.
 *
 * These values are public identifiers, not secrets. They name the project and
 * the web app. Access is controlled by Firestore Security Rules and Firebase
 * Auth, never by hiding these values.
 *
 * Project: chorechampion-app
 */
export default {
  apiKey: "AIzaSyCslv59jEkfWJtQId_4eun-RWwIe2KNFEo",
  authDomain: "chorechampion-app.firebaseapp.com",
  projectId: "chorechampion-app",
  storageBucket: "chorechampion-app.firebasestorage.app",
  messagingSenderId: "438352693439",
  appId: "1:438352693439:web:5bfa74ab8384b18b5c9e0a"
};
